package com.sddamico.draftmachine.components.widgets

import androidx.compose.runtime.Composable
import com.sddamico.draftmachine.data.DraftStatus
import com.sddamico.draftmachine.ds.core.Badge
import com.sddamico.draftmachine.ds.core.BadgeTone
import com.varabyte.kobweb.compose.ui.Modifier

@Composable
fun StatusBadge(status: DraftStatus?, modifier: Modifier = Modifier) {
  when (status) {
    DraftStatus.ACTIVE -> Badge("Drafting", tone = BadgeTone.Glass, dot = true, modifier = modifier)
    DraftStatus.SETUP -> Badge("Draft pending", tone = BadgeTone.Patina, dot = true, modifier = modifier)
    DraftStatus.COMPLETE -> Badge("Complete", tone = BadgeTone.Verde, dot = true, modifier = modifier)
    DraftStatus.CANCELLED -> Badge("Cancelled", tone = BadgeTone.Rust, modifier = modifier)
    null -> Badge("No drafts", tone = BadgeTone.Neutral, modifier = modifier)
  }
}
